/** آدرس اپ مدیریت پروژه (dev: پورت 4000) */
export function getProjectManagerAppUrl(path = '/'): string {
  const configured = import.meta.env.VITE_PM_APP_URL as string | undefined;
  if (configured) {
    const base = configured.replace(/\/$/, '');
    return `${base}${path.startsWith('/') ? path : `/${path}`}`;
  }
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    return `http://${window.location.hostname}:4000${path.startsWith('/') ? path : `/${path}`}`;
  }
  return `/panel/project-manager${path.startsWith('/') ? path : `/${path}`}`;
}
